import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "formContainer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { colspan: "2" }
const _hoisted_6 = { class: "py-3" }
const _hoisted_7 = { class: "py-3" }
const _hoisted_8 = { class: "py-3" }
const _hoisted_9 = { class: "py-3" }
const _hoisted_10 = { class: "py-3" }
const _hoisted_11 = { class: "py-3" }
const _hoisted_12 = { class: "py-3" }
const _hoisted_13 = { class: "d-flex justify-content-end" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Organizational boundaries",
        text: "Organizational boundaries",
        class: "mb-0"
      }),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addOrEditPremises(null)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Add new premises",
              text: "Add new premises"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_op_table, {
        class: "table table-striped",
        items: _ctx.premises
      }, {
        default: _withCtx((opData) => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Premises type",
                  text: "Premises type"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Location",
                  text: "Location"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Area m2",
                  text: "Area m2"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Headcounts",
                  text: "Headcounts"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Operational approach (%)",
                  text: "Operational approach (%)"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Financial control (%)",
                  text: "Financial control (%)"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Equity share (%)",
                  text: "Equity share (%)"
                })
              ]),
              _hoisted_3
            ])
          ]),
          _createElementVNode("tbody", null, [
            (opData.data.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                  _createElementVNode("td", _hoisted_5, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.Premises[]), (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.address), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.squareMeters), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.headCounts), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(item.operationalApproachPercentage) + "%", 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.financialControlPercentage) + "%", 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.equitySharePercentage) + "%", 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: "btn btn-tertiary",
                      onClick: ($event: any) => (_ctx.addOrEditPremises(item))
                    }, [
                      (_ctx.isReadOnly)
                        ? (_openBlock(), _createBlock(_component_localized_text, {
                            key: 0,
                            localizedKey: "Detail",
                            text: "Detail"
                          }))
                        : (_openBlock(), _createBlock(_component_localized_text, {
                            key: 1,
                            localizedKey: "Edit",
                            text: "Edit"
                          }))
                    ], 8, _hoisted_14)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["items"])
    ])
  ], 64))
}